import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "../../../models/app-filter.model";
import { AbIntegrador } from "app/abstract/full-pages/integrador/integrador.abstract";

@Injectable({ providedIn: 'root' })
export class IntegradorService extends AbIntegrador {

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public desativarIntegrador(id: number, senha: string) {
  const body = senha;
    return this.http.delete(this.url + `admin/integradores/desativar/${id}`, { body });
  }

  public getAllIntegradores(filter: AppFilter) {
    return this.get('admin/integradores/filter/' + filter.encode());
  }

  public getAllIntegradoresAtivos(): Observable<any> {
    return this.getAll("admin/integradores/ativos");
  }

  public getAllAtivosFilter(filter: AppFilter) {
    return this.get('admin/integradores/ativos/' + filter.encode());
  }
  public getMigrarAppConfig(id: number) {
    return this.get('admin/integradores/migrar_app_config/', id);
  }

  public getAllContratos(appFilter: AppFilter) {
    return this.getAll('admin/contratos/filter/' + appFilter.encode());
  }

  public deletarContrato(id: number) {
    return this.delete('admin/contratos/', id);
  }

  public saveOrUpdate(integradorId: number, entity: any) {
    if (integradorId && entity.id)
      return this.http.put(this.url + 'admin/contratos/update/' + integradorId, entity);

    return this.http.post(this.url + 'admin/contratos/create/' + integradorId, entity);
  }

  public saveIntegrador(form: any) {
    return this.save('admin/integradores/', form);
  }

  public getById(id: number) {
    return this.get("admin/integradores/", id)
  }

  public getByDocumento(documento: string) {
    return this.get("admin/integradores/documento/" + documento);
  }

  public formatarData(data: any): Date {
    if (!data) return;

    const tempData = Object.assign({}, data);
    const newDate = new Date();
    newDate.setDate(tempData.day);
    newDate.setMonth(tempData.month - 1);
    newDate.setFullYear(tempData.year);
    return newDate;
  }

  public formatarDataFilter(data: any): Date {
    if (!data) return;

    const tempData = this.tratarDataFilter(data);
    const newDate = new Date();
    newDate.setDate(tempData.day);
    newDate.setMonth(tempData.month - 1);
    newDate.setFullYear(tempData.year);
    return newDate;
  }

  public tratarDataFilter(data) {
    let tempData = JSON.parse(JSON.stringify(data));
    if (tempData.match(/[/-]/g)) {
      tempData = tempData.split(/[/-]/g);
      tempData = { year: Number(tempData[2]), month: Number(tempData[1]), day: Number(tempData[0]) };
    }
    return tempData;
  }


  public tratarData(data) {
    let tempData = JSON.parse(JSON.stringify(data));
    if (tempData.match(/[/-]/g)) {
      tempData = tempData.split(/[/-]/g);
      tempData = { year: Number(tempData[0]), month: Number(tempData[1]), day: Number(tempData[2]) };
    }
    return tempData;
  }

  public getIntegradorContaLogada() {
    return this.get('admin/integradores/integrador/contalogada');
  }

  public getIntegradorPossuiContratoDeContaOuUnidade(integradorId: number) {
    return this.get(`admin/integradores/integrador/${integradorId}/contrato`);
  }

  public getTemplateWhatsAppIntegrador() {
    return this.get(`admin/skin/simulacao/template`);
  }

  public postSimularEnvioWhatsAppIntegrador(whatsapp: any) {
    return this.post(`admin/skin/mensagens`, whatsapp);
  }

  public getWhatsAppIntegrador(integradorId: number) {
    return this.get(`admin/skin/whatsapp/${integradorId}`);
  }

  public putWhatsAppIntegrador(integradorId: number, whatsapp: any) {
    return this.put(`admin/skin/whatsapp`, integradorId, whatsapp);
  }

  public getPreCadastroIntegrador(uuid: string) {
    return this.get(`public/admin/config-integrador/web/${uuid}`);
  }

  public updatePreCadastro(uuid: string, habilitarPreCadastro: boolean): Observable<any> {
    return this.http.put(`${this.url}admin/config_integrador/pre-cadastro/${uuid}`, { habilitarPreCadastro });
  }

  public getAmbienteCustomizado(integradorId: number): Observable<boolean> {
    return this.get<boolean>(`admin/integradores/${integradorId}/ambiente-customizado`);
  }

  public ativarNovoModeloBusca(): Observable<void> {
    return this.http.put<void>(`${this.url}admin/v1/config-integrador/codigo-pre-cadastro/ativar`, null);
  }
}
